import '@helga-agency/tableofcontents/TableOfContentsElement';
import AnchorVisibilityHandler from './src/AnchorVisibilityHandler';
import NavigationVisibilityHandler from './src/NavigationVisibilityHandler';

NavigationVisibilityHandler.defineElement();
AnchorVisibilityHandler.defineElement();
